export interface IDeveloperDto {
  email: string;
  userType: string;
}

export class DeveloperDto implements IDeveloperDto {
  public email: string;
  public userType: string;

  constructor(email: string, userType: string,) {
    this.email = email;
    this.userType = userType;
  }
}
